'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.agentTypeToSenderType = undefined;

var _agentTypes = require('../../pubnub-message/constants/agentTypes');

var _senderTypes = require('../../pubnub-message/constants/senderTypes');

var agentTypeToSenderType = exports.agentTypeToSenderType = function agentTypeToSenderType(agentType, isRep) {
  return agentType === _agentTypes.HUMAN ? isRep ? _senderTypes.AGENT : _senderTypes.VISITOR : _senderTypes.BOT;
};